<div class="upload z-fx-col z-fx-gap-24">
  <div class="upload-grid" [ngClass]="size">
    <image-upload-area [fit]="fit"></image-upload-area>

    @if (gallery) {
      @if (preloading()) {
        <zef-spinner></zef-spinner>
      }
      @for (image of images$ | async; track image.name) {
        <image-upload-item [image]="image"></image-upload-item>
      }
    }
  </div>

  @if (gallery && (startImages$ | async)?.length > 2 && (showAll$ | async) === false) {
    <div class="zef-text-light zef-text-center zef-text-link zef-text-underline zef-text-p2" (click)="showAll()" i18n>
      Show all
    </div>
  }
</div>
